var Vendd = (function (Vendd) {
    'use strict';

    Vendd.OfferSubscription = (function (OfferSubscription) {

        OfferSubscription.Messages = (function (Messages) {

            Messages.SubscribeToOffer = function (formData) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OfferSubscription.Messages.SubscribeToOffer', formData);
            };
            Messages.SubscribeToOffer.className = 'Vendd.OfferSubscription.Messages.SubscribeToOffer';

            Messages.SubscribeToOfferSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OfferSubscription.Messages.SubscribeToOfferSuccess', response);
            };
            Messages.SubscribeToOfferSuccess.className = 'Vendd.OfferSubscription.Messages.SubscribeToOfferSuccess';

            Messages.SubscribeToOfferFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.OfferSubscription.Messages.SubscribeToOfferFailure', response);
            };
            Messages.SubscribeToOfferFailure.className = 'Vendd.OfferSubscription.Messages.SubscribeToOfferFailure';

            return Messages;

        })(OfferSubscription.Messages || {});

        return OfferSubscription;

    })(Vendd.OfferSubscription || {});

    return Vendd;

})(Vendd || {});
